import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { RequestObserverService } from 'src/app/core/services/common/request-observer.service';

@Component({
  selector: 'app-stateful-internal-link',
  templateUrl: './stateful-internal-link.component.html',
  styleUrls: ['./stateful-internal-link.component.scss'],
})
export class StatefulInternalLinkComponent {
  @Input() text: string;
  @Input() pageUrl: string;
  @Input() stateId: any;
  @Input() clickEvent: () => Promise<unknown>;
  @Input() hasHover = false;
  @Input() disabled = false;
  @Input() bypassNav = false;
  selected = false;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'small',
  };

  constructor(
    private router: Router,
    private requestObserver: RequestObserverService
  ) {}

  isImage(text: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    const extension = text.substring(text.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(extension);
  }

  async submit(): Promise<boolean> {
    if (!this.requestObserver.isAcceptingRequest()) return false;
    this.requestObserver.beginRequest();
    this.selected = true;

    if (this.clickEvent !== undefined) {
      const response = await this.clickEvent()
        .then((res: unknown) => res as boolean)
        .catch((exception) => {
          this.selected = false;
          this.requestObserver.endRequest();
          return false;
        });
      if (!response) {
        this.selected = false;
        this.requestObserver.endRequest();
        return response;
      }
    }

    this.router.navigate([this.pageUrl], {
      queryParams: { stateId: this.stateId },
    });
    this.requestObserver.endRequest();
    return true;
  }
}
